import { getMonthlyPrice } from './pricingCalculations';
export const getMaximalMonthlyPrice = _ref => {
  var _Object$values$sort;
  let {
    catalogPricing,
    salePricing
  } = _ref;
  // find the shortest cycle
  const smallestCyclePricing = (_Object$values$sort = Object.values(salePricing ?? catalogPricing).sort((a, b) => (a.monthsPerCycle ?? 0) - (b.monthsPerCycle ?? 0))) == null ? void 0 : _Object$values$sort[0];
  return smallestCyclePricing ? getMonthlyPrice(smallestCyclePricing) : 0;
};
//# sourceMappingURL=getMaximalMonthlyPrice.js.map